<template>
  <div>
    <md-button
      v-if="canAddSupply"
      :disabled="loading"
      @click="prepareCreate"
      class="floating md-primary md-just-icon md-round"
    >
      <md-icon>add</md-icon>
    </md-button>
    <md-toolbar style="height: 70px" class="md-primary" md-elevation="1">
      <div class="md-layout md-alignment-top">
        <div class="md-layout-item md-size-20">
          <h3 class="md-title" style="flex: 1">Insumos</h3>
        </div>
        <div class="md-layout-item md-size-40">
          <div class="outlined-field">
            <md-field md-inline>
              <label>Buscar</label>
              <md-input :disabled="loading" v-model="searchQuery"></md-input>
            </md-field>
          </div>
        </div>
        <div class="md-layout-item md-size-40">
          <div class="outlined-field">
            <md-field>
              <label>Tipo</label>
              <md-select
                @input="filterData"
                :disabled="loading"
                v-model="supplyTypeSelected"
                name="supplyTypeSelected"
                id="supplyTypeSelected"
              >
                <md-option :value="c.id" v-for="c in supplyTypes" :key="c.id">{{ c.name }}</md-option>
              </md-select>
            </md-field>
          </div>
        </div>
      </div>
    </md-toolbar>

    <md-list class="md-scrollbar">
      <md-content v-if="queriedData.length && !loading">
        <template v-for="sup in queriedData">
          <div :key="sup.id">
            <supply-item
              :supply="sup"
              :show-icons="currentlyShow === sup.id"
              :expanded-copies="displayedCopies[sup.id]"
              @remove-supply="deleteItem"
              @show-copies="showCopies(sup)"
              @mouseover.native="showIcons(sup.id)"
              @mouseleave.native="showIcons(sup.id, false)"
              @clicked-edit="prepareEdit"
              @clicked-edit-with-camp="
                prepareEdit($event, { openCampTab: true })
              "
            />
          </div>
          <!-- copies -->
          <div v-if="sup.copies.length && displayedCopies[sup.id]" class="copies-list">
            <md-subheader style="margin-bottom: -30px; margin-top: -10px" class="text-center">
              <strong>Copias</strong>
            </md-subheader>
            <div v-for="copy in sup.copies" :key="copy.id" class="md-layout">
              <supply-item
                class="md-layout-item md-size-90 mx-auto"
                :show-icons="currentlyShow === copy.id"
                :supply="copy"
                @remove-supply="deleteItem"
                @mouseover.native="showIcons(copy.id)"
                @mouseleave.native="showIcons(copy.id, false)"
                @clicked-edit="prepareEdit"
                @clicked-edit-with-camp="
                  prepareEdit($event, { openCampTab: true })
                "
              />
            </div>
          </div>
        </template>
      </md-content>
      <loading-content
        v-if="!queriedData.length && !loading"
        empty-icon="widgets"
        empty-label="No hay insumos que mostrar"
        :empty-description="emptyDescription"
      />
    </md-list>

    <editModal
      v-if="classicModal"
      :isRegister="isRegister"
      :editedItem="item"
      :subFamilyId="subFamilyId"
      :familyId="familyId"
      :defaultTab="modalTab"
      :catalogs="catalogs"
      @saved="updateElement"
      @close="classicModalHide"
      @error="classicModalHide"
    />

    <modalShow
      v-if="showModalShow"
      :editedItem="item"
      @close="closeShowModal"
      @error="closeShowModal"
    >
      <template slot="header">
        <h4>Detalle de Insumo</h4>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="closeShowModal"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>
    </modalShow>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import editModal from "./SupplyModal";
import dataService from "@/services/catalog";
import modalShow from "./showSupply";
import Fuse from "fuse.js";
import SupplyItem from "./SupplyItem";

import { flatten } from "lodash";
import { iterateDelayed } from "@/utils";
import mapPermissions from "@/plugins/accountPermissions/mapPermissions";

export default {
  name: "ListSupplies",
  props: {
    subFamilyId: 0,
    familyId: 0,
    loading: {
      type: Boolean,
    },
    catalogs: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  components: {
    editModal,
    modalShow,
    SupplyItem,
  },
  data() {
    return {
      modalTab: null,
      showModalShow: false,
      classicModal: false,
      hover: false,
      currentlyShow: null,
      search: "",
      showSidepanel: false,
      supplyTypeSelected: -1,

      fuseSearch: null,
      propsToSearch: ["name", "code"],
      searchQuery: "",
      searchedData: [],
      displayedCopies: {},
      supplies: [],
    };
  },

  computed: {
    ...mapPermissions("Services", "supply", ["add"]),
    emptyDescription() {
      if (!this.subFamilyId) {
        return "Seleccione una subfamilia para ver sus insumos.";
      }
      return "La subfamilia no tiene insumos.";
    },

    // filteredSupplies() {
    //   return this.currentSupplies;
    // },

    ...mapGetters({ filterSupply: "catalogs/filterSupply" }),
    queriedData() {
      let supplies = this.supplies;
      if (this.searchedData && this.searchedData.length > 0) {
        supplies = this.searchedData;
      }

      const copies = supplies.filter(({ code = "" }) => code.endsWith("CP"));

      const originalSupplies = supplies
        .filter(({ code = "" }) => !code.endsWith("CP"))
        .map((s) => ({
          ...s,
          copies: copies.filter(({ code = "" }) => code.startsWith(s.code)),
        }));

      /*
      get ungrouped copies, shold not happen but if it does
      the copies wouldn't be displayed
      */
      const groupedCopies = {};
      flatten(originalSupplies.map(({ copies }) => copies)).forEach(
        ({ id }) => {
          groupedCopies[id] = true;
        }
      );

      const ungrouped = copies.filter((c) => !groupedCopies[c.id]);

      return [...ungrouped, ...originalSupplies];
    },

    supplyTypes() {
      return [{ id: -1, name: "Todos" }, ...this.catalogs.supplyTypes];
    },
  },

  methods: {
    closeShowModal() {
      this.showModalShow = false;
    },

    prepareShow(c) {
      // get element selected from table
      this.item = c; // make copy of element selected
      this.showModalShow = true; // show modal
    },

    deleteItem(c) {
      this.$confirmMessage({ title: "¿Eliminar el insumo?" }, () => {
        this.supplies = this.supplies.filter((sup) => sup.id !== c.id);
        return dataService
          .delete("services/supplies", c, { useStore: true })
          .then(() => this.$successMessage({ title: `Almacen borrado` }))
          .catch(this.$fireErrorResponse);
      });
    },

    showIcons(index, show = true) {
      this.hover = show;
      this.currentlyShow = index;
    },

    updateElement({ original, updated }) {
      if (!original.id) {
        this.createdE(updated);
      } else {
        this.editElement(updated, original);
      }
    },

    createdE(h) {
      dataService
        .create("services/supplies", h, { useStore: true })
        .then((item) => {
          if (h.newPictograms.length) {
            let uploadPictograms = h.newPictograms.map((p) => {
              return { supplyId: item.id, ...p };
            });
            return iterateDelayed(uploadPictograms, 500, this.sendPhotos).then(
              () => {
                dataService.fetchSupply(item.id).then((res) => {
                  this.supplies.push(res);
                  this.$successMessage({
                    title: `${item.name} fue creado con pictogramas`,
                  });
                });
              }
            );
          } else {
            dataService.fetchSupply(item.id).then((res) => {
              this.supplies.push(res);
              this.$successMessage({
                title: `Creando Nuevo Insumo: ${item.name}`,
              });
            });
          }
        })
        .catch(this.$fireErrorResponse)
        .finally(() => this.classicModalHide());
    },
    classicModalHide() {
      this.classicModal = false;
    },

    prepareCreate() {
      this.isRegister = true;
      this.item = {};
      this.classicModal = true;
    },

    prepareEdit(c, opts = {}) {
      this.item = c; // make copy of element selected
      this.isRegister = false; // Modal in mode edition
      this.classicModal = true; // show modal
      this.modalTab = opts.openCampTab ? "camp-supply" : "supply-form";
    },

    editElement(updated, original) {
      dataService
        .update("services/supplies", updated, original, { useStore: true })
        .then((h) => {
          if (updated.newPictograms.length) {
            let uploadPictograms = updated.newPictograms.map((p) => {
              return { supplyId: h.id, ...p };
            });
            return iterateDelayed(uploadPictograms, 500, this.sendPhotos).then(
              () => {
                dataService.fetchSupply(h.id).then((res) => {
                  this.supplies.splice(
                    this.supplies.findIndex((i) => i.id === original.id),
                    1,
                    res
                  );
                  this.$successMessage({
                    title: `${h.name} fue Editado con nuevos pictogramas`,
                  });
                });
              }
            );
          } else {
            dataService.fetchSupply(h.id).then((res) => {
              this.supplies.splice(
                this.supplies.findIndex((i) => i.id === original.id),
                1,
                res
              );
              this.$successMessage({ title: `${h.name} fue Editado` });
            });
          }
        })
        .catch(this.$fireErrorResponse)
        .finally(() => this.classicModalHide());
    },
    sendPhotos(photo) {
      return dataService.uploadPictograms(photo);
    },
    showCopies({ id: supplyId }) {
      this.displayedCopies[supplyId] = !this.displayedCopies[supplyId];
    },
    filterData(type) {
      this.$emit("setLoading", true);
      const promise = new Promise((resolve) => {
        this.supplies = this.filterSupply(this.subFamilyId, type);
        resolve();
      });
      return promise.then(() => {
        this.$emit("setLoading", false);
      });
    },
  },

  mounted() {
    this.fuseSearch = new Fuse(this.supplies, {
      threshold: 0.3,
      keys: this.propsToSearch,
    });
  },

  watch: {
    subFamilyId: {
      inmediate: true,
      handler(subfamily) {
        this.$emit("setLoading", true);
        this.supplyTypeSelected = -1;
        this.searchQuery = "";
        const promise = new Promise((resolve) => {
          this.supplies = this.filterSupply(subfamily, this.supplyTypeSelected);
          resolve();
        });
        return promise.then(() => {
          this.$emit("setLoading", false);
        });
      },
    },
    supplies(newList) {
      this.fuseSearch.list = newList;
    },

    searchQuery(value) {
      let result;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },

    queriedData(supplies = []) {
      const displayedCopies = {};
      supplies.forEach((s) => {
        displayedCopies[s.id] = false;
      });

      this.displayedCopies = displayedCopies;
    },
  },
};
</script>

<style scoped lang="scss">
@import "~vue-material/dist/theme/engine"; // Import the theme engine

.floating {
  width: 40px !important;
  height: 40px !important;
  position: absolute;
  top: 78px;
  left: 8px;
  z-index: 2;
}

.md-content {
  max-height: 70vh;
  overflow: auto;
}
.md-button.md-fab,
.md-button.md-just-icon {
  z-index: 4;
}

.md-list-item-content > .md-icon:first-child {
  margin-right: 0%;
}
.md-menu-content:not(.md-select-menu)
  .md-menu-content-container
  .md-list
  .md-list-item:not(:last-child) {
  margin-bottom: 0px;
}
.md-list-item-content {
  min-height: 48px;
  padding: 4px 16px;
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  transition: padding 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  will-change: padding;
}

.md-tooltip {
  font-size: 16px !important;
}

.copies-list {
  background: md-get-palette-color(grey, 300);
}
.md-layout-item {
  padding: 0 2px;
}
.md-scrollbar {
  width: 100%;
}

.outlined-field {
  background-color: white;
  outline: none;
  border: none;
  padding: 4px 10px;
  border-radius: 4pt;
  height: fit-content;
  .md-field {
    transform: unset;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Catalogs/Supplies/Existence/ListSupplies.vue